import React, { FC } from "react";
import { Slide as MuiSlide } from "@mui/material";

type Props = React.ComponentProps<typeof MuiSlide>;

const Slide: FC<Props> = (props) => {
    return <MuiSlide {...props}/>
}

export default Slide;